// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2CmOC","colMin":"styles_colMin__3mZaC","colCheckbox":"styles_colCheckbox__3jmo4"};